import { render, staticRenderFns } from "./paywayTelegramChat.vue?vue&type=template&id=280d7afd&scoped=true&"
import script from "./paywayTelegramChat.vue?vue&type=script&lang=js&"
export * from "./paywayTelegramChat.vue?vue&type=script&lang=js&"
import style0 from "./paywayTelegramChat.vue?vue&type=style&index=0&id=280d7afd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d7afd",
  null
  
)

export default component.exports